import { render, staticRenderFns } from "./donorTable.vue?vue&type=template&id=6f60b1a8"
import script from "./donorTable.vue?vue&type=script&lang=js"
export * from "./donorTable.vue?vue&type=script&lang=js"
import style0 from "./donorTable.vue?vue&type=style&index=0&id=6f60b1a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports